import { render, staticRenderFns } from "./ButtonWithMenu.vue?vue&type=template&id=647bf767&"
import script from "./ButtonWithMenu.vue?vue&type=script&lang=js&"
export * from "./ButtonWithMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports